﻿$(document).ready(function () {
    $(".read-more-btn").click(function () {
        var $reveal = $(this).siblings(".reveal");
        var $parent = $(this).parent();

        if ($parent.hasClass("open")) {
            $reveal.css("max-height", "0");
            $parent.removeClass("open");
            $(this).removeClass("open").text("Show all");
        } else {
            $reveal.css("max-height", "none");
            $parent.addClass("open");
            $(this).addClass("open").text("Show less");
        }
    });
});

